// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1-ERtGPiwyVL00 {\n  color: #5E6C84;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  line-height: 20px;\n  margin-bottom: 4px;\n  margin-top: 8px;\n  text-transform: uppercase;\n}\n._1KjsyHJ1dQLRr9:not(._2XlmaOd0C0MdJF) {\n  justify-content: start;\n}\n@media only screen and (max-width: 750px) {\n  ._1KjsyHJ1dQLRr9 {\n    width: calc(50% - 8px);\n    margin-right: 8px;\n  }\n}\n._1VuWlwZ2p7OleX {\n  margin-bottom: 0;\n  margin-top: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "_1-ERtGPiwyVL00",
	"button": "_1KjsyHJ1dQLRr9",
	"loading": "_2XlmaOd0C0MdJF",
	"popoverButton": "_1VuWlwZ2p7OleX"
};
export default ___CSS_LOADER_EXPORT___;
